/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { columns, defaultFilter, filterForm, editForm } from './utils/list_data';
import { institutionsAPI } from 'src/api/modules/institutions';
import CustomButton from 'src/common/components/CustomButton';
import PageLayout from 'src/common/components/PageLayout';
import FullTable from 'src/common/components/FullTable';
import notice from 'src/common/components/Notice';
import DeleteOrg from './Modals/DeleteOrg';
import { Add } from '@material-ui/icons';
import EditOrg from './Modals/EditOrg';
import AddOrg from './Modals/AddOrg';

const Organizations = () => {
	const [filter, setFilter] = useState(defaultFilter);
	const [organizations, setOrganizations] = useState([]);
	const [organizationsName, setOrganizationsName] = useState([]);
	const [organizationsPre, setOrganizationsPre] = useState([]);
	const [idOrganization, setIdOrganization] = useState([]);
	const [addOrgModal, setAddOrgModal] = useState(false);
	const [editModal, setEditModal] = useState(false);
	const [deleteModal, setDeleteModal] = useState(false);

	useEffect(() => {
		geAlltInstitutions();
	}, []);

	useEffect(() => {
		if (filter.organizacion || filter.prefijo || filter.estatus) {
			onConfirmFilter();
		} else {
			getInstitutions();
		}
	}, []);

	const geAlltInstitutions = () => {
		let filterName = [];
		let filterPre = [];
		institutionsAPI
			.getAllinstitutions('OR')
			.then((response) => {
				if (response.instituciones && response.instituciones.length > 0) {
					response.instituciones.forEach((item) => {
						filterName.push({
							value: item.id,
							text: item.nombre,
						});

						if (item.prefijo !== '' && item.prefijo !== undefined)
							filterPre.push({
								value: item.id,
								text: item.prefijo,
							});
					});

					setOrganizationsName(filterName);
					setOrganizationsPre(filterPre);
				}
			})
			.catch((e) => notice('Ocurrio un error', 'error'));
	};

	const getInstitutions = () => {
		institutionsAPI
			.getAllinstitutions('OR')
			.then((response) => {
				if (response.instituciones && response.instituciones.length > 0) {
					setOrganizations(response.instituciones);
				}
			})
			.catch((e) => notice('Ocurrio un error', 'error'));
	};

	const onCloseModalAdd = () => {
		setIdOrganization(editForm);
		setAddOrgModal(false);
	};

	const onCloseModalEdit = () => {
		setIdOrganization(editForm);
		setEditModal(false);
	};

	const onSuccess = (msg, type_msg, type) => {
		notice(msg, type_msg);
		switch (type) {
			case 1:
				onCloseModalAdd();
				break;
			case 2:
				onCloseModalEdit();
				break;
			case 3:
				setDeleteModal(false);
				break;
			default:
				break;
		}
		getInstitutions();
	};

	const onConfirmFilter = () => {
		if (filter.organizacion !== null)
			institutionsAPI
				.institutionId(filter.organizacion.value)
				.then((response) => {
					setOrganizations(response.instituciones);
				})
				.catch(() => {
					notice('Ha ocurrido un error con la busqueda');
				});
		else if (filter.prefijo !== null)
			institutionsAPI
				.institutionPrefijo(filter.prefijo.text, 'OR')
				.then((response) => {
					setOrganizations(response.instituciones);
				})
				.catch(() => {
					notice('Ha ocurrido un error con la busqueda');
				});
		else if (filter.estatus !== null)
			institutionsAPI
				.institutionStatus(filter.estatus, 'OR')
				.then((response) => {
					setOrganizations(response.instituciones);
				})
				.catch(() => {
					notice('Ha ocurrido un error con la busqueda');
				});
	};

	const onNewOrg = () => {
		setAddOrgModal(true);
	};

	const onEditOrg = (dataRow) => {
		setIdOrganization(dataRow);
		setEditModal(true);
	};

	const onDelete = (dataRow) => {
		setIdOrganization(dataRow);
		setDeleteModal(true);
	};

	const onStatus = (dataRow) => {
		institutionsAPI
			.changeinstitucionStatus(
				dataRow.estatus === 'A' ? 'I' : 'A',
				dataRow.id,
				dataRow.prefijo
			)
			.then(() => {
				notice(
					`La organización se ${
						dataRow.estatus === 'I' ? 'activo' : 'inactivo'
					} correctamente.`,
					'success'
				);
			})
			.catch(() => {
				notice(
					`Ocurrio un error al ${
						dataRow.estatus === 'I' ? 'acctivar' : 'desactivar'
					} la organización.`
				);
			});

		getInstitutions();
	};

	const onClear = () => {
		setFilter(defaultFilter);
		getInstitutions();
	};

	const handleChangeFilter = ({ target }) => {
		const { name, value } = target;

		if (name === 'organizacion') {
			filter.prefijo = null;
			filter.estatus = null;
		}
		if (name === 'prefijo') {
			filter.organizacion = null;
			filter.estatus = null;
		}
		if (name === 'estatus') {
			filter.organizacion = null;
			filter.prefijo = null;
		}

		setFilter({ ...filter, [name]: value });
	};

	const onChangeData = ({ target }) => {
		setIdOrganization({ ...idOrganization, [target.name]: target.value });
	};

	return (
		<PageLayout>
			<CustomButton
				mainText="Nueva Organización"
				color="primary"
				className="m-3"
				icon={Add}
				style={{
					position: 'absolute',
					right: 35,
				}}
				onClick={() => {
					onNewOrg();
				}}
			/>
			<FullTable
				title="Organizaciones"
				items={organizations}
				columns={columns(onDelete, onEditOrg, onStatus)}
				filter={filter}
				filterForm={filterForm(
					onConfirmFilter,
					onClear,
					organizationsName,
					organizationsPre
				)}
				onFilterChange={handleChangeFilter}
				showPagination
				useBackendPagination={false}
			/>
			<AddOrg
				open={addOrgModal}
				parent={idOrganization}
				onClose={onCloseModalAdd}
				onSuccess={onSuccess}
				onChangeData={onChangeData}
			/>
			<DeleteOrg
				open={deleteModal}
				onSuccess={onSuccess}
				onDelete={onDelete}
				organization={idOrganization}
				onClose={() => {
					setDeleteModal(false);
				}}
			/>
			<EditOrg
				open={editModal}
				onClose={onCloseModalEdit}
				onSuccess={onSuccess}
				onDelete={onEditOrg}
				organization={idOrganization}
				onChangeData={onChangeData}
			/>
		</PageLayout>
	);
};

export default Organizations;
